import { render } from "./UploadForm.vue?vue&type=template&id=17089950&scoped=true"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"

import "./UploadForm.vue?vue&type=style&index=0&id=17089950&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17089950"

export default script